var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 18.9066C18.5 19.7863 17.7721 20.5 16.875 20.5H7.125C6.22786 20.5 5.5 19.7863 5.5 18.9066V5.09675C5.5 4.21704 6.22786 3.50331 7.125 3.5H14.0346C14.4646 3.5 14.8776 3.66929 15.1823 3.96806L18.0227 6.75327C18.3274 7.05204 18.5 7.46036 18.5 7.88196V18.9066ZM7.125 19.4376H16.875C17.1729 19.4376 17.4167 19.1986 17.4167 18.9065V8.81471H13.8958C13.4456 8.81471 13.0833 8.4595 13.0833 8.01799V4.56554H7.125C6.82709 4.56554 6.58333 4.80456 6.58333 5.09668V18.9065C6.58333 19.1986 6.82709 19.4376 7.125 19.4376ZM17.3997 7.75242H14.1667V4.58213C14.2615 4.60538 14.3461 4.65183 14.4172 4.72157L17.2575 7.50675C17.3287 7.57648 17.376 7.65947 17.3997 7.75242Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.e5e94154eb3062562b4a975f58ec48ff.svg";
export { ForwardRef as ReactComponent };